import React from 'react';
import useCriticalErrorStore from '@store/useCriticalErrorStore';
import './CriticalErrorBanner.css';

/**
 * CriticalErrorBanner - Displays when system is in critical error state
 * Shows a red banner at the top of the screen with error message
 * Includes a refresh button to reload the page
 */
function CriticalErrorBanner() {
  const { hasCriticalError, errorMessage, errorSource } = useCriticalErrorStore();

  if (!hasCriticalError) {
    return null;
  }

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="critical-error-banner">
      <div className="critical-error-banner__icon">⚠️</div>
      <div className="critical-error-banner__content">
        <span className="critical-error-banner__title">Realm Instability</span>
        <span className="critical-error-banner__message">
          {errorMessage || 'The realm has become unstable!'}
        </span>
      </div>
      <button
        className="critical-error-banner__refresh-btn"
        onClick={handleRefresh}
      >
        Restore Order
      </button>
    </div>
  );
}

export default CriticalErrorBanner;
